/*
 *  			'License for ONE AXA SOFTWARE - Inner Source'
 * 					L O A S - I S
 * 
 * The following License aims to be applied between the AXA Companies, according to the following definition:
 * "AXA Companies" means AXA, Société Anonyme with a “AXA Companies ” Board of Directors having its principal offices at 25, avenue Matignon, 75008 Paris, registered on the Commercial Registry of Paris under the number 572 093 920; and (i) any other company controlled by, or controlling AXA, with a company being considered as controlling another: (a) when it holds directly or indirectly a portion of the capital according to it the majority of the voting rights in general meetings of shareholders of this company; (b) when it holds solely the majority of the voting rights in this company by virtue of an agreement concluded with other partners or shareholders and which is not contrary to the interest of the company; (c) when it determines de facto, by voting rights which it holds, the decisions in the general meetings of shareholders of this company; (d) in any event, when it holds, directly or indirectly, a portion of voting rights greater than 40% and when no other partner or shareholder holds directly or indirectly a portion which is greater than its own; (ii) any economic interest group in which AXA and/or one or more other Companies of the AXA Group participates for at least 50% in operating costs; (iii) in the cases where the law applicable to a company limits voting rights or control (such as defined here in above), this company will be deemed to be a company of the AXA Group, if the voting rights in 2 Binding Corporate Rules – AXA Group – version 2013 general shareholders’ meetings or the control held by a Company of the AXA Group reaches the maximum amount fixed by said applicable law; and (iv) all AXA Companies constitute the “AXA Group” (hereafter "One AXA").  (Binding Corporate Rules - AXA Group - version 2019).
 * 
 * Software credits: 
 * 	Creator: AXA GO GETD
 * 	Main contributors: AXA GO GETD
 * 
 * Permission is hereby granted, free of charge, to any person or entity within One AXA obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software within One AXA, including the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * 
 * The above credit notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * Any improvement or modification of the Software shall be made available to the whole One AXA, under the terms of this License.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import css from 'styled-jsx/css';

export default css.global`
  @import url(https://fonts.googleapis.com/css?family=Open+Sans);

  #backdropFlow {
    position: absolute;
    z-index: 1;
    border: 0px solid #685972;
    background-color: #fff;
    overflow: hidden;
    pointer-events: none;
    transition: transform 1s;
    margin-top: 3.19em;
    margin-left: 12px;
    border: none;
    padding-bottom: 5em;
  }

  #highlightsFlow {
    white-space: pre-wrap;
    word-wrap: break-word;
    color: transparent;
    min-height: 97px;
  }

  #flowtextAreaForm {
    display: block;
    position: absolute;
    z-index: 2;
    margin: 0;
    border: 2px solid #74637f;
    border-radius: 0;
    color: #444;
    background-color: transparent;
    overflow: auto;
    resize: none;
    transition: transform 1s;
  }

  mark {
    border-radius: 3px;
    color: transparent;
    background-color: #b1d5e5;
    padding: 3px;
    margin: -3px;
  }
  #marked {
    background-color: #b1d5e5;
  }

  .flow_description .ant-form-item-explain-error {
    background-color: white !important;
    margin: 20px;
  }

  #importMark {
    background-color: rgb(254, 243, 199);
  }
  #translationsTitleMark {
    background-color: rgb(252, 211, 77);
  }
  #translationsBodyMark {
    background-color: rgb(251, 191, 36);
  }
  #restartMark {
    background-color: rgb(209, 250, 229);
  }

  #nlpMark {
    background-color: rgb(110, 231, 183);
  }
  #dialogMark {
    background-color: rgb(52, 211, 153);
  }

  #runMark {
    background-color: rgb(219, 234, 254);
  }
  #cardMark {
    background-color: rgb(224, 231, 255);
  }

  #callMark {
    background-color: rgb(237, 233, 254);
  }
  #sayMark {
    background-color: rgb(252, 231, 243);
  }
  #askMark {
    background-color: rgb(254, 226, 226);
  }

  #setMark {
    background-color: rgb(191, 219, 254);
  }
  #incMark {
    background-color: rgb(199, 210, 254);
  }
  #decMark {
    background-color: rgb(221, 214, 254);
  }
  #dialogTitleMark {
    background-color: rgb(251, 207, 232);
  }
  #dialogDescriptionMark {
    background-color: rgb(147, 197, 253);
  }
  #dialogCategoryMark {
    background-color: rgb(165, 180, 252);
  }
  #dialogTypeMark {
    background-color: rgb(196, 181, 253);
  }
  #setComment {
    background-color: rgb(209, 213, 219);
  }

  #errorMark {
    background-color: #ffd2d2;
    border-width: 2px;
    font-weight: bolder;
    border-style: dashed;
    border-color: red;
  }

  dialogTypeMark dialogDescriptionMark section.ds-page {
    overflow-y: unset !important;
  }
  .overflow-y-auto {
    overflow: unset !important;
  }

  footer {
    display: flex;
    position: fixed;
    bottom: 0;
    text-align: center;
    width: 100%;
  }

  .ant-input-affix-wrapper-textarea-with-clear-btn .ant-input-clear-icon {
    z-index: 10;
  }

  #buttonDivFooter {
    float: right;
    padding-left: 1em;
    z-index: 10;
    margin: 1em;
    padding-top: 2em;
    position: relative;
  }
  .ant-form-item-explain.ant-form-item-explain-error {
    z-index: 10;
    margin-left: 1em;
  }

  #flowtextAreaForm::placeholder {
    color: #777777;
  }
`;
